import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width={19}
    height={19}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Union"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.7 1.95H6.3V3.55H1.7V1.95ZM0 5.25V0.25H8V5.25H0ZM12.7 8.45H17.3V10.05H12.7V8.45ZM11 11.75V6.75H19V11.75H11ZM17.3 15.45H12.7V17.05H17.3V15.45ZM11 13.75V18.75H19V13.75H11ZM2.99995 6.25V17.25H3V17.25H10V15.55H4.69995V10.25H10V8.55005H4.69995V6.25H2.99995Z"
      fill="#222A5C"
    />
  </svg>,
  "Subaccounts"
);
